import type { Root } from "mdast";
import { visit } from "unist-util-visit";

export function mentionsPlugin() {
    return (tree: Root) => {
        visit(tree, function (node) {
            if (node.type !== "textDirective" || node.name !== "mention") return;

            // Manipulate the AST node in-situ to convert the directive into a span...
            const data = node.data ?? (node.data = {});
            const attributes = node.attributes ?? {};
            data.hName = "span";
            const textNode = node.children.find(n => n.type === "text");
            if (textNode)
                textNode.value = "@" + textNode.value;
            data.hProperties = {
                className: "mention-directive",
                title: attributes.value
            };
        });
    }
}